import {
  differenceInDays,
  format,
  formatISO,
  isValid,
  parseISO,
} from 'date-fns';
import { localeMappings } from '@/lib/types';
import { enUS } from 'date-fns/locale';

export { differenceInDays };

export function monthsToYearsAndMonths(months: number): string {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  const yearsLabel = years > 1 ? 'years' : 'year';
  const monthsLabel =
    remainingMonths === 0 || remainingMonths > 1 ? 'months' : 'month';

  if (years === 0) {
    return `${remainingMonths} ${monthsLabel}`;
  }

  if (remainingMonths === 0) {
    return `${years} ${yearsLabel}`;
  }

  return `${years} ${yearsLabel} ${remainingMonths} ${monthsLabel}`;
}

export function formatDateISOString(dateString: string): string {
  const date = parseISO(dateString);
  return isValid(date) ? format(date, 'dd/MM/yyyy') : '';
}

export function formatDate(date: Date): string {
  return isValid(date) ? format(date, 'dd/MM/yyyy') : '';
}

export function ISODateStringToDate(
  isoDateString: string | undefined,
): Date | undefined {
  if (!isoDateString) return undefined;
  const date = parseISO(isoDateString);
  return isValid(date) ? date : undefined;
}

export function toISODateString(date: string | number | Date): string {
  const parsed = new Date(date);
  return isValid(parsed) ? formatISO(parsed, { representation: 'date' }) : '';
}

export function isValidDate(date: any): boolean {
  if (!date) return false;
  return isValid(new Date(date));
}

export function formatDateWithShortMonth(
  dateString: string,
  localeKey: string,
): string {
  const date = parseISO(dateString);
  if (!isValid(date)) return '';

  const locale = localeMappings[localeKey] || enUS;
  return format(date, 'dd MMM yyyy', { locale });
}

export const isValidData = (date: any) => {
  return date && isValid(new Date(date));
};

export const dateWithoutTime = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};
